if (!customElements.get('pfd-post')) {
  customElements.define('pfd-post', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      const body = this.querySelector('[data-article-body]');
      const firstHeading = body?.firstElementChild;
      const normalize = text => text.trim().replace(/\s+/g, ' ').toLowerCase();
      if (firstHeading?.matches('h2') && normalize(firstHeading.textContent) === normalize(this.dataset.articleTitle || '')) {
        firstHeading.hidden = true;
      }
      const toc = this.querySelector('[data-article-toc]');
      const list = this.querySelector('[data-toc-list]');
      const headings = Array.from(body?.querySelectorAll('h2:not([hidden]), h3:not([hidden])') || []);
      if (toc && list && headings.length > 1) {
        list.replaceChildren();
        headings.forEach((heading, index) => {
          if (!heading.id) heading.id = `PfdPost-${this.dataset.articleId}-heading-${index + 1}`;
          const item = document.createElement('li');
          if (heading.tagName === 'H3') item.className = 'pfd-post-toc-subheading';
          const link = document.createElement('a');
          link.href = `#${encodeURIComponent(heading.id)}`;
          link.textContent = heading.textContent.trim();
          item.append(link);
          list.append(item);
        });
        toc.hidden = false;
        const mobile = window.matchMedia('(max-width: 989px)');
        toc.open = !mobile.matches;
        mobile.addEventListener('change', event => { toc.open = !event.matches; }, options);
      }
      body?.querySelectorAll('table').forEach(table => {
        if (table.parentElement.classList.contains('pfd-post-table-scroll')) return;
        const wrapper = document.createElement('div');
        wrapper.className = 'pfd-post-table-scroll';
        wrapper.tabIndex = 0;
        wrapper.setAttribute('role', 'region');
        wrapper.setAttribute('aria-label', table.caption?.textContent || 'Article table');
        table.before(wrapper);
        wrapper.append(table);
      });
      const copyButton = this.querySelector('[data-copy-link]');
      if (copyButton) {
        copyButton.hidden = false;
        copyButton.addEventListener('click', async () => {
          const feedback = this.querySelector('[data-share-feedback]');
          const status = this.querySelector('[data-share-status]');
          const fallback = this.querySelector('[data-copy-fallback]');
          feedback.hidden = false;
          try {
            if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
            await navigator.clipboard.writeText(copyButton.dataset.url);
            if (!this.isConnected) return;
            fallback.hidden = true;
            status.textContent = 'Article link copied.';
          } catch {
            if (!this.isConnected) return;
            status.textContent = 'Select and copy the article link below.';
            fallback.hidden = false;
            const input = fallback.querySelector('input');
            input.focus();
            input.select();
          }
        }, options);
      }
    }
    disconnectedCallback() {
      this.events?.abort();
    }
  });
}
